import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Resetpassword.css";
import { validateForm } from "../../Utils/validate";
import { gettoastsuccess, gettoastwarning } from "../../Utils/Common";
import API from '../../Utils/Api';
import CustomLoader from "../../components/CustomLoader";

const Resetpassword = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const routeData = location.state || {};
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showValidations, setShowValidations] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputs, setInputs] = useState({ password: '', confirm_password: '' });
  // Validations
  const validations = {
    length: inputs.password.length >= 8,
    number: /\d/.test(inputs.password),
    upperLower: /[a-z]/.test(inputs.password) && /[A-Z]/.test(inputs.password),
    specialChar: /[^A-Za-z0-9]/.test(inputs.password)
  };
  const handleInputChange = (event) => {
    setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
  }
  // Helper: choose correct image
  const getIcon = (isValid) => process.env.REACT_APP_BASE_URL + (isValid ? "assests/images/icon_valid.png" : "assests/images/icon_invalid.png");

  /* ---- Reset Password ---- */
  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log('inputs.accept_terms', inputs.accept_terms);

    const fields = [
      { field: 'password', label: 'Password', rules: 'required|strong_password', value: inputs.password },
      { field: 'confirm_password', label: 'Confirm Password', rules: 'required|matches:password', value: inputs.confirm_password }
    ];
    console.log('fields', fields);
    const errors = validateForm(fields);
    if (Object.keys(errors).length > 0) {
      setErrors(errors);
    } else {
      setErrors({});
      doResetPassword();
    }
  }
  const doResetPassword = async () => {
    setLoading(true);
    let error;
    try {
      const formInputs = { id: routeData?.id, reset_password: inputs.password }
      console.log('reset_password inputs', formInputs);
      API.post('reset_password', formInputs)
        .then(response => {
          setLoading(false);
          console.log('reset_password response', response.data);
          if (response.data.status === false) {
            gettoastwarning(response.data.message);
          } else {
            gettoastsuccess('Your password has been changed successfully!', '', 2000);
            setTimeout(() => {
              navigate("/login/", { replace: true });
            }, 2000);
          }
        }).catch(e => {
          error = e.message;
          gettoastwarning(error);
        });
    } catch (e) {
      setLoading(false);
      error = e.message;
      gettoastwarning(error);
    }
  };
  useEffect(() => {
    document.title = `Reset Password | Your Friend My Friend`;
    document.getElementById('bodywrap').className = 'brand';
  }, []);

  return (
    <>
      <CustomLoader loading={loading} />
      <div className="container-fluid d-flex align-items-center justify-content-center min-vh-100 lo-oma position-relative">
        <div className="back-btn d-flex gap-1" onClick={() => navigate(-1)}>
          <img
            src={process.env.REACT_APP_BASE_URL + "assests/images/left-frame.png"}
            alt="back"
            className="img-fluid"
          />
          back
        </div>
        <div className="row w-100 my-5">
          <div className="col-md-6 col-lg-4 mx-auto">
            <div className="p-2">
              <h3 className="text-center">Reset password</h3>
              <p className="text-center omas-p mb-0">Your new password must be different</p>
              <p className="text-center omas-p niku">from previously used passwords.</p>

              <form method="post" onSubmit={handleSubmit} encType="multipart/form-data">
                {/* Password */}
                <div className="mb-3">
                  <div className={`input-group ${errors.password ? 'form-error' : ''}`}>
                    <span className="input-group-text">
                      <img
                        src={process.env.REACT_APP_BASE_URL + "assests/images/icon_password.png"}
                        alt="password"
                        className="img-fluid input-icon"
                      />
                    </span>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      placeholder="Password"
                      name="password"
                      value={inputs.password}
                      onChange={(e) => {
                        handleInputChange(e);
                        if (!showValidations) setShowValidations(true);
                      }}
                    />
                    <span
                      className="input-group-text"
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          (showPassword
                            ? "assests/images/icon_eye.png"
                            : "assests/images/icon_eye_slash.png")
                        }
                        alt="toggle-visibility"
                        className="img-fluid input-icon"
                      />
                    </span>
                  </div>
                  {errors.password && (
                    <p className="text-danger error-text">{errors.password}</p>
                  )}
                  {showValidations && (
                    <div className="mt-2">
                      <div className="condtions-or d-flex align-items-start gap-2 mb-1 mt-1">
                        <img src={getIcon(validations.length)} alt="condition" className="img-fluid validation-icon" />
                        At least 8 characters
                      </div>
                      <div className="condtions-or d-flex align-items-start gap-2 mb-1">
                        <img src={getIcon(validations.number)} alt="condition" className="img-fluid validation-icon" />
                        At least 1 number
                      </div>
                      <div className="condtions-or d-flex align-items-start gap-2 mb-1">
                        <img src={getIcon(validations.specialChar)} alt="condition" className="img-fluid validation-icon" />
                        At least 1 special character
                      </div>
                      <div className="condtions-or d-flex align-items-start gap-2">
                        <img src={getIcon(validations.upperLower)} alt="condition" className="img-fluid validation-icon" />
                        Both upper and lower case letters
                      </div>
                    </div>
                  )}
                </div>

                <div className="mb-4">
                  <div className={`input-group ${errors.confirm_password ? 'form-error' : ''}`}>
                    <span className="input-group-text">
                      <img
                        src={process.env.REACT_APP_BASE_URL + "assests/images/icon_password.png"}
                        alt="password"
                        className="img-fluid input-icon"
                      />
                    </span>
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className="form-control"
                      placeholder="Confirm Password"
                      value={inputs.confirm_password}
                      name="confirm_password"
                      onChange={handleInputChange}
                    />
                    <span className="input-group-text" style={{ cursor: "pointer" }} onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                      <img
                        src={
                          process.env.REACT_APP_BASE_URL +
                          (showConfirmPassword
                            ? "assests/images/icon_eye.png"
                            : "assests/images/icon_eye_slash.png")
                        }
                        alt="toggle-visibility"
                        className="img-fluid input-icon"
                      />
                    </span>
                  </div>
                  {errors.confirm_password && (
                    <p className="text-danger error-text">{errors.confirm_password}</p>
                  )}
                </div>

                {/* Login button */}
                <div className="d-grid mb-3 mt-3 text-center">
                  {/* <Link to="/login" className="logus-in text-decoration-none">reset password</Link> */}
                  <button className="logus-in" type="submit">
                    reset password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Resetpassword;
